export async function initStageReport({
  token,
  userId,
  email,
  name,
  userType,
  reportId,
  themeName,
  totalPuzzles,
  currentTheme,
  stageToggles,
}) {
  const tokenStr = String(token ?? '').trim();
  const [sessionIdFromToken, organizationIdFromToken] = tokenStr.includes('&')
    ? tokenStr.split('&')
    : [null, null];
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/initStageReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      email,
      name,
      user_type: userType,
      reportid: reportId,
      themeName,
      ...(totalPuzzles != null && Number.isFinite(Number(totalPuzzles))
        ? { total_puzzles: Number(totalPuzzles) }
        : {}),
      // Lets the backend look up the theme's own saved piece count instead of
      // trusting whatever total_puzzles this particular browser has cached —
      // two players joining around the same time as an admin change could
      // otherwise each get checked against a different capacity limit.
      ...(currentTheme ? { currentTheme: String(currentTheme) } : {}),
      ...(stageToggles && typeof stageToggles === 'object' ? stageToggles : {}),
      ...(sessionIdFromToken ? { sessionId: String(sessionIdFromToken) } : {}),
      ...(organizationIdFromToken ? { organizationId: String(organizationIdFromToken) } : {}),
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to initialize stage report');
  }
  return data;
}

export async function updateStageFeedback({ token, userId, dayNumber, feedback, stageId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStageFeedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      dayNumber,
      feedback,
      stageId,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update stage feedback');
  }
  return data;
}
